import { useAppSelector } from 'hooks/redux';
import React, { useState } from 'react';

import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import IconButton from '@mui/material/IconButton';
import type { IconButtonProps } from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import Tooltip from '@mui/material/Tooltip';
import { featureFlagsSelectors } from 'app-components/flux/feature-flags';

const DevMenuButton = ({ children, ...other }: IconButtonProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | undefined>(undefined);
  return (
    <>
      <Tooltip title='Those menus are only for dev purpose and visible in development builds only - it is not available in production builds!'>
        <IconButton
          sharedcomponentid='DevMenuButton'
          onClick={(e) => {
            setAnchorEl(e.currentTarget);
          }}
          {...other}
        >
          <BuildOutlinedIcon />
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchorEl} id='dev-menu' open={Boolean(anchorEl)} onClose={() => setAnchorEl(undefined)}>
        {React.Children.toArray(children)
          .filter((child): child is React.ReactElement<any> => React.isValidElement(child))
          .map((child) =>
            React.cloneElement(child, {
              onClick: (event: React.MouseEvent<HTMLElement>) => {
                if (child.props.onClick) {
                  child.props.onClick(event);
                }
                setAnchorEl(undefined);
                event.stopPropagation();
              },
            }),
          )}
      </Menu>
    </>
  );
};

const DevMenuButtonWrapper = (props: IconButtonProps) => {
  const dev = useAppSelector((state) => featureFlagsSelectors.getFeatureFlag(state, 'dev'));
  if (!dev) {
    return null;
  }
  return <DevMenuButton {...props} />;
};

export default DevMenuButtonWrapper;
